module.exports = __webpack_public_path__ + "img/21.b7d37319.svg";